<template>
    <div>
        <div v-if="all_robot_sku_list && all_robot_sku_list.length > 0 && all_count > 0"

             style="position: fixed; right: -1px; bottom: 230px">
            <Badge :count="all_count" show-zero style="position: absolute;"></Badge>
<!--            <Badge :count="no_pushed_count" show-zero type="warning" style="position: absolute; margin-left: 25px"></Badge>-->
<!--            <Badge :count="pushed_count" type="primary" show-zero style="position: absolute; margin-left: 50px"></Badge>-->

            <van-button
                    style="margin-left: 9px; margin-top: 9px;"
                    type="danger"
                    @click="showRobotSkuList"
            >助理清单
            </van-button>
        </div>

        <!--选品清单sheet-->
        <Wp_join_robot_list_Sheet ref="Wp_join_robot_list_Sheet"
                                  @updataBadgeCountAndData="updataBadgeCountAndData"
        ></Wp_join_robot_list_Sheet>

    </div>
</template>

<script>
    import Wp_join_robot_list_Sheet from "./Wp_join_robot_list_Sheet";
    import {Toast} from "vant";
    export default {
        name: "Wp_join_robot_list_mark_model",
        components: {Wp_join_robot_list_Sheet},
        provide() {
            return {
                WpJoinRobotListMark: this
            }
        },

        props:{
            // allRobotSkuList: {type: Array},
            allRobotSkuData: {type: Object},
            // showMark: {type: Boolean, default: false}//手动调用显示mark
            dataStemp: {type: Number, default: 0}
        },

        data(){
            return{
                //选品清单，内容为skuId
                select_skuId_list: [],
                //选品清单中的商品信息集合
                select_skuInfo_list: [],

                //添加到选品清单中的商品数量上限
                select_sku_length_limit: 9,

                all_robot_sku_list: [],
                all_count: 0,
                no_pushed_count: 0,
                pushed_count: 0,
            }
        },

        watch:{
            allRobotSkuData:{
                handler(newData){
                    this.getAllRobatSkuData(newData)
                },
                deep: true
            },
        },

        created() {
            // setTimeout(()=>{
            //     this.initRobotSkuListMark();
            // }, 2000);
            this.initRobotSkuListMark();
        },

        methods:{
            /**
             * 助理清单标记的初始化
             */
            initRobotSkuListMark(){
                if(this.allRobotSkuData && this.allRobotSkuData.list){
                    this.all_robot_sku_list = this.allRobotSkuData.list;
                    this.initBadgeCount();
                }else if(this.$common.global_sku_all_data && this.$common.global_sku_all_data.list){
                    this.all_robot_sku_list = this.$common.global_sku_all_data.list;
                    this.initBadgeCount();
                }
            },

            /**
             * 显示商品清单
             */
            showRobotSkuList() {
                if (this.all_robot_sku_list && this.all_robot_sku_list.length > 0) {
                    const toast = Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: '清单加载中...'
                    });
                    setTimeout(()=>{
                        toast.clear();
                        if (this.all_robot_sku_list && this.all_robot_sku_list.length > 0) {
                            this.$refs.Wp_join_robot_list_Sheet.showRobotSkuSheet();
                        }
                    }, 1500);
                }
            },

            updataBadegSync(addOne){
                this.all_count = this.all_count + addOne;
            },

            getAllRobatSkuData(data){
                if(data && data.list){
                    let list = data.list;
                    this.all_robot_sku_list = list;

                    this.initBadgeCount();
                }
            },

            initBadgeCount(){
                this.all_count = this.all_robot_sku_list.length;
                this.no_pushed_count = 0;
                this.pushed_count = 0;
                for(let i = 0; i < this.all_robot_sku_list.length; i++){

                    if(this.all_robot_sku_list[i].task_status === 0){
                        //未推送
                        this.no_pushed_count++;
                    }

                    if(this.all_robot_sku_list[i].task_status === 1){
                        //已推送
                        this.pushed_count++
                    }
                }
            },

            /**
             * 更新角标数字已经完整数据（来自Wp_join_robot_list_sheet）
             */
            updataBadgeCountAndData(newCount, data){
                //更新按钮状态
                this.updataJoinRobotButtonStatus();

                this.all_count = this.all_count - (this.no_pushed_count - newCount);
                this.no_pushed_count = newCount;

                this.all_robot_sku_list = data.list;

            },

            updataJoinRobotButtonStatus(){
                this.$emit("updataJoinRobotButtonStatus");
            },


            /**
             * 添加商品到发品清单中
             */
            addInRobotList(skuInfo, skuId) {
                if (this.select_skuInfo_list.length === this.select_sku_length_limit) {
                    this.$dialog.alert({
                        message: '[发品清单]以达到最大限额'
                    });
                    return;
                }

                if (this.select_skuId_list.includes(skuId)) {
                    // this.$toast.fail("该商品已加入[选品清单]")
                    this.$dialog.alert({
                        message: '该商品已加入[发品清单]'
                    });
                } else {
                    this.select_skuInfo_list.push(skuInfo)
                    this.select_skuId_list.push(skuId)
                }
            },

            releaseRobotListData(){
                this.$refs.Wp_join_robot_list_Sheet.releaseSelectData();
            }
        }
    }
</script>

<style scoped>

</style>